"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Loading;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Loading() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "frikin-loader loading-placeholder"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fas fa-circle-notch fa-spin"
  }));
}